import Modal from "src/pages/Modals/ModalBase";
import { useDispatch, useSelector } from "react-redux";
import { showBlockedThreadWarnPopup } from "src/store/slices/messageSlice";
import { Warning } from "@phosphor-icons/react";

const BlockedThreadWarning = () => {
  const dispatch = useDispatch();
  const showModal = useSelector((state) => state.messageSlice.blockedThreadWarnPopup);

  const handleClose = () => {
    dispatch(showBlockedThreadWarnPopup(false));
  };

  return (
    <Modal
      isOpen={showModal}
      className="w-[700px] h-full p-0"
      onClose={handleClose}
      bodyClassName={"py-0 !rounded-[16px]"}
      closeBtnClassName={"right-4 top-4"}
    >
      <div className="flex flex-col items-center justify-center py-[48px] px-[32px] gap-[16px]">
        <div className="w-[52px] h-[52px] bg-[#FEF3C7] rounded-full flex items-center justify-center">
          <Warning size={28} weight="fill" className="text-[#F59E0B]" />
        </div>
        <h2 className="text-[20px] font-[600] text-[#1A1A1A] text-center">Chat Read-Only</h2>
        <p className="text-[15px] font-[400] text-[#666666] text-center max-w-[400px]">
          This chat is now read-only following an AI upgrade to improve your experience. To continue, start a new
          conversation or contact{" "}
          <a href="mailto:support@inhouse.ai" className="text-[#3F65A9] underline">
            support@inhouse.ai
          </a>{" "}
          for help with this thread.
        </p>
      </div>
    </Modal>
  );
};

export default BlockedThreadWarning;
